import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueFormulate from '@braid/vue-formulate'
import store from './store'
import axios from 'axios'

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@braid/vue-formulate/dist/snow.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

const baseURL = process.env.VUE_APP_API_URL;

const axiosInstance = axios.create({
  baseURL,
})

const toastOptions = {
    // You can set your default options here
    timeout: 30_000,
};

Vue.use(Toast, toastOptions);

Vue.use(VueFormulate, {
  uploader: axiosInstance,
  uploadUrl: '/api/therapists/photos',
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
